import { buildSurveyTeamSlotIso, parseSurveyTeamScheduledSlots, surveyTeamSlotMatchesDate } from '../../../../api/strapiCrm';

export function removeDateFromSlotsMap(
  prev: Map<string, string[]>,
  date: string,
): Map<string, string[]> {
  const next = new Map<string, string[]>();
  for (const [userId, rawList] of prev.entries()) {
    const remaining = rawList.filter((raw) => !surveyTeamSlotMatchesDate(raw, date));
    if (remaining.length > 0) next.set(userId, remaining);
  }
  return next;
}

/** Pindahkan semua slot pada `fromDate` ke `toDate` (jam dipertahankan). */
export function moveDateInSlotsMap(
  prev: Map<string, string[]>,
  fromDate: string,
  toDate: string,
): Map<string, string[]> {
  if (fromDate === toDate) return prev;
  const next = new Map<string, string[]>();
  for (const [userId, rawList] of prev.entries()) {
    const remapped: string[] = [];
    for (const raw of rawList) {
      const parsed = parseSurveyTeamScheduledSlots([raw])[0];
      if (!parsed) continue;
      if (parsed.date !== fromDate) {
        remapped.push(raw);
        continue;
      }
      if (parsed.timeLabel) {
        remapped.push(buildSurveyTeamSlotIso(toDate, parsed.timeLabel));
      } else {
        remapped.push(toDate);
      }
    }
    const unique = [...new Set(remapped)].sort();
    if (unique.length > 0) next.set(userId, unique);
  }
  return next;
}

export function moveDateInDateOnlySlots(
  slots: string[],
  fromDate: string,
  toDate: string,
): string[] {
  if (fromDate === toDate) return [...slots].sort();
  return [...new Set(slots.filter((date) => date !== fromDate).concat(toDate))].sort();
}

export type AdoptTeamMemberInput = {
  userId: string;
  timeLabels: string[];
};

/**
 * Update satu tanggal saja: hapus `fromDate`, lalu assign roster `teamMembers` di `toDate`.
 * Slot tanggal lain milik anggota yang sudah ada tetap utuh.
 */
export function buildSlotsAdoptingTeamOnSingleDate(opts: {
  previousSlots: Map<string, string[]>;
  fromDate: string;
  toDate: string;
  teamMembers: AdoptTeamMemberInput[];
}): Map<string, string[]> {
  const next = removeDateFromSlotsMap(opts.previousSlots, opts.fromDate);

  for (const member of opts.teamMembers) {
    const userId = String(member.userId ?? '').trim();
    if (!userId) continue;
    const hhmm = member.timeLabels.find((label) => /^\d{2}:\d{2}$/.test(label.trim()));
    const onTarget = hhmm ? buildSurveyTeamSlotIso(opts.toDate, hhmm) : opts.toDate;
    const existing = next.get(userId) ?? [];
    const withoutToDate = existing.filter((raw) => !surveyTeamSlotMatchesDate(raw, opts.toDate));
    next.set(userId, [...new Set([...withoutToDate, onTarget])].sort());
  }

  return next;
}
